<template>
  <div class="main-width">

    <div>
      <div v-show="activeName == 'protein'">
        <SubmitProteinBlock :homeBlock="'Yes'"></SubmitProteinBlock>
      </div>


    </div>


  </div>
</template>

<script>
import SubmitProteinBlock from "@/components/searchBlock/SubmitProteinBlock.vue";


// import DivUnit from "@/components/DivUnit.vue";
// import * as echarts from "echarts";
// import api from "../api/index";
import pathUrl from "../api/path";
export default {
  name: "HomeView",
  data() {
    return {
      activeName: "protein",
      localUrl: pathUrl.localUrl,
    };
  },
  components: {
    SubmitProteinBlock,


  },

  methods: {},
  beforeMount() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
@color-protein: #409eff;
@color-rna: #60bb64;
@color-dna: #63789b;
@color-compartment: #cfa158;
/deep/.div-title {
  display: none !important;
}
.tag-icon {
  transition: All 0.4s ease-in-out;
  -webkit-transition: All 0.4s ease-in-out;
  -moz-transition: All 0.4s ease-in-out;
  -o-transition: All 0.4s ease-in-out;
}

.tag-normal:hover {
  .tag-icon {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
  }
}

.tag-normal {
  display: flex;
  height: 60px;

  cursor: pointer;
  border-radius: 30px;
  .tag-icon {
    margin: auto 0;
    width: 50px;
    height: 50px;
    background: #fafafa;
    border-radius: 25px;
    margin-left: 6px;
    display: flex;
  }
  .tag-icon-hover {
    margin-right: 18px;
    display: flex;
    .fa {
      font-size: 27px;
      margin: auto;
    }
  }
  .tag-title {
    margin: auto;
    font-size: 24px;
    padding-left: 12px;
    padding-right: 50px;
    width: 120px;
    text-align: center;
    font-weight: bold;
    font-style: italic;
  }
  .icon {
    margin: auto;
    font-size: 27px;
  }
}
.tag-protein {
  background: @color-protein;
  border: 2px solid @color-protein;
  color: @color-protein;
  .icon {
    color: @color-protein;
  }
}
.tag-rna {
  background: @color-rna;
  border: 2px solid @color-rna;
  color: @color-rna;
  .icon {
    color: @color-rna;
  }
}

.tag-dna {
  background: @color-dna;
  border: 2px solid @color-dna;
  color: @color-dna;
  .icon {
    color: @color-dna;
  }
}
.tag-compartment {
  background: @color-compartment;
  border: 2px solid @color-compartment;
  color: @color-compartment;
  .icon {
    color: @color-compartment;
  }
}
.deactive {
  background: #fafafa;
}
.active {
  color: #fafafa;
}

/deep/.el-tabs__header {
  top: 271px;
}

/deep/.el-tabs__nav-wrap::after {
  background-color: transparent;
}
</style>
